<template>
  <div name="unit_edit">
    <savenotice :title="'Unit'" ref="saveNoticeTop"></savenotice>

    <div
      class="w-full mx-auto grid space-x-10 py-4 border-b border-gray-300"
      v-bind:class="[isNew ? 'grid-cols-1' : ' grid-cols-3 ']"
    >
      <div class="bg-white rounded-lg p-6">
        <form v-on:submit.prevent="processCourse()" class="w-95p mx-auto">
          <div class="flex flex-wrap -mx-3 mb-8">
            <div class="w-11/12">
              <label class="form-label" for="grid-title"> Title </label>
              <input
                v-model="name"
                class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                id="grid-title"
                type="text"
                placeholder="Enter unit course name"
              />
              <p class="text-gray-600 text-xs italic">
                The title will appear on the Planning Grid -
                <span class="text-red-300 text-xs italic"
                  >Please fill out this field.</span
                >
              </p>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3 mb-8">
            <div class="w-11/12">
              <label class="form-label" for="grid-desc"> Description </label>
              <textarea
                v-model="description"
                id="grid-desc"
                class="mb-2 focus:border-red-200 focus:bg-white focus:outline-none p-2"
                type="text"
                placeholder="Enter a description for the unit course here"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3 mb-6 w-11/12">
            <div class="w-full md:w-1/2 pr-3 mb-6 md:mb-0">
              <label class="form-label" for="grid-year"> Year Group </label>
              <dropdown
                :options="yearDropdown"
                :selected="selectedYear"
                id="grid-year"
                v-on:updateOption="yearSelect"
                mode="form"
                class="bg-gray-100"
              ></dropdown>
              <p class="text-red-300 text-xs italic mt-1">
                Please fill out this field.
              </p>
            </div>
            <div class="w-full md:w-1/2 pr-3 mb-6 md:mb-0">
              <label class="form-label" for="grid-category"> Category </label>
              <dropdown
                :options="catDropdown"
                :selected="selectedCat"
                id="grid-category"
                v-on:updateOption="catSelect"
                mode="form"
                class="bg-gray-100"
              ></dropdown>
              <p class="text-red-300 text-xs italic mt-1">
                Please fill out this field.
              </p>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3 mb-8">
            <div class="w-full">
              <label class="form-label" for="grid-title">
                Visible On System
              </label>
              <button
                type="button"
                class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
                v-bind:class="[
                  true === isActive
                    ? 'bg-action-blue bg-opacity-50 text-white'
                    : 'bg-gray-200 text-gray-600',
                ]"
                @click="isActive = true"
              >
                Active
              </button>

              <button
                type="button"
                class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-times"
                v-bind:class="[
                  false === isActive
                    ? 'bg-action-blue bg-opacity-75 text-white'
                    : 'bg-gray-200 text-gray-600',
                ]"
                @click="isActive = false"
              >
                Off
              </button>
              <p class="text-red-300 text-xs mt-1 italic">
                Please fill out this field.
              </p>
            </div>
          </div>

          <div class="w-11/12 -mx-3 mb-6 mt-4">
            <button
              type="submit"
              class="publish-button hover:opacity-75 w-full"
              v-bind:class="
                !isDisabled
                  ? 'cursor-pointer'
                  : 'bg-gray-200 cursor-not-allowed'
              "
              :disabled="isDisabled"
            >
              Publish Changes
            </button>

            <savenotice
              :title="'Unit'"
              ref="saveNoticeBottom"
              class="left pl-6"
            ></savenotice>
          </div>
        </form>
      </div>

        <div class="bg-white rounded-lg p-6" v-if="!isNew">
            <TheLessonOrder v-if="course != undefined" :course="course"> </TheLessonOrder>

        </div>

      <div class="bg-white rounded-lg p-6" v-if="!isNew">
        <CurriculumResources v-if="course != undefined" :course="course"> </CurriculumResources>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const dropdown = () => import("@/components/Dropdown.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
const CurriculumResources = () =>
  import("@/components/curriculum/CurriculumResources.vue");
const TheLessonOrder = () =>
  import("@/components/curriculum/LessonOrder.vue");

import { SchoolService } from "@/services/school.service";

export default {
  name: "unit_edit",
  props: {
    cats: { type: Array, required: true },
    years: { type: Array, required: true },
    course: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    isDisabled() {
      if (
        this.selectedCat.id > 0 &&
        this.selectedYear.id > 0 &&
        this.name.length > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    isNew() {
      return this.course.id === undefined;
    },
    yearDropdown() {
      let results = [{ id: 0, name: "Select a year group" }].concat(this.years);
      if (this.selectedYear === undefined) {
        this.selectedYear = results[0];
      }
      return results;
    },
    catDropdown() {
      var results = [{ id: 0, name: "Select a category" }].concat(this.cats);
      if (this.selectedCat === undefined) {
        this.selectedCat = results[0];
      }
      return results;
    },
  },
  data() {
    return {
      name: this.course.name === undefined ? "" : this.course.name,
      description:
        this.course.description === undefined ? "" : this.course.description,
      isActive: this.course.active === 0 ? false : true,
      selectedYear: {},
      selectedCat: undefined,
    };
  },
  created() {
    let vm = this;
    if (vm.course.category != undefined) {
      vm.selectedCat = vm.cats.find((cat) => vm.course.category.id == cat.id);
    }
    vm.selectedYear = vm.years.find((year) => vm.course.year_id == year.id);
  },
  methods: {
    processCourse() {
      let typeId = this.isContentAdmin ? 1 : this.currentUser.typeID;

      // values
      this.course.name = this.name;
      this.course.description =
        this.description == undefined ? null : this.description;
      this.course.type_id = typeId;
      this.course.category_id = this.selectedCat.id;
      this.course.year_id = this.selectedYear.id;
      this.course.active = this.isActive === true ? 1 : 0;
      this.course.updated_at = new Date();
      this.course.should_sync = 1;
      this.course.styles = this.currentUser.schoolStyle;

      // add new or update
      if (this.course.id === undefined) {
        this.course.inserted_at = this.course.updated_at;

        SchoolService.create("courses", this.course)
          .then((response) => this.updateCourseAddition(response.data))
          .catch((err) => {
            this.completion(err);
          });
      } else {
        SchoolService.update("courses", this.course.id, this.course)
          .then((response) => this.completion())
          .catch((err) => {
            this.completion(err);
          });
      }
    },
    updateCourseAddition(data) {
      this.course.id = data.id;
      this.newCourseAdded(true);
      completion();
    },
    completion() {
      this.$refs.saveNoticeTop.saved();
      this.$refs.saveNoticeBottom.saved();
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.$refs.saveNoticeTop.failed();
      this.$refs.saveNoticeBottom.failed();
      console.log("Course crud error " + error);
    },
    newCourseAdded(reload) {
      this.$emit("tab", 1);
      this.$emit("append", this.course.id);
      window.scrollTo(0, 0);
    },
    yearSelect(year) {
      this.selectedYear = year;
    },
    catSelect(cat) {
      this.selectedCat = cat;
    },
  },
  components: {
    dropdown,
    savenotice,
    CurriculumResources,
    TheLessonOrder
  },
};
</script>

<style scoped>
</style>
